import { Card } from "@/components/ui/card";
import { JsonViewer } from "@/components/ui/json-viewer";

interface McpErrorCardProps {
  error: {
    code: number;
    message: string;
    data?: unknown;
  };
}

export function McpErrorCard({ error }: McpErrorCardProps) {
  return (
    <Card className="p-3 border-destructive">
      <div className="space-y-2">
        <h5 className="text-sm font-medium text-destructive">Error Response</h5>
        <div className="text-sm">
          <span className="font-medium">Code:</span> {error.code}
        </div>
        <div className="text-sm">
          <span className="font-medium">Message:</span> {error.message}
        </div>
        {!error.data ? null : (
          <JsonViewer
            data={error.data}
            title="Error Data"
            defaultExpanded={true}
          />
        )}
      </div>
    </Card>
  );
}
